import { Card, Col, Row } from "antd";
import AppTitle from "../app-title/app-title";

const advantages = [
  {
    id: 1,
    title: <><span style={{ color: "#F67828" }}>Большой выбор</span> европейских авто и полуприцепов в наличии и под заказ</>,
    text: "В наличии грузовики марки DAF, Volvo, Scania, а также прицепы Schmitz и Krone. Привезём технику под заказ по вашим потребностям",
  },
  {
    id: 2,
    title: <>Машины с <span style={{ color: "#F67828" }}>полным пакетом</span> документов</>,
    text: "Все авто прошли таможенное оформление, уплачены пошлины, установлены системы ЭРА-Глонасс и получены ЭПТС со статусом действующий",
  },
  {
    id: 3,
    title: <><span style={{ color: "#F67828" }}>5 центров</span> по России</>,
    text: "Удобное расположение в Тольятти, Казань, Набережные челны, Уфа и Екатеринбург",
  },
  {
    id: 4,
    title: <>Приобретение в <span style={{ color: "#F67828" }}>лизинг</span></>,
    text: "Работаем с любой лизинговой компанией. Предлагаем выгодные расчёты от Альфа лизинг.",
  },
];

const aboutCompany = [
  "Компания General Trucks – ваш надежный партнер по продаже техники для грузоперевозок!",
  "Компания успешно работает с 2018 года и специализируется на предоставлении качественных грузовиков марок DAF, Scania и Volvo – как новых, так и с пробегом. Мы также предлагаем полуприцепы Schmitz и Krone.",
  "Наши 5 центров оборудованы современными сервисными установками и запчастями высокого качества. Наша команда экспертов обеспечит надежное и профессиональное обслуживание вашего транспорта.",
  "Если вы ищете надежного партнера для приобретения техники для грузоперевозок и получения качественного сервиса, обращайтесь к нам. ‌General Trucks готов предложить вам лучшие решения грузовой техники.",
];

function MainPageAdvantagesSection() {
  return (
    <>
      <AppTitle text={"Преимущества"} />
      <Row gutter={40} style={{ margin: 0, display: "block" }}>
        <div className="main__avantages content">
          {advantages.map((item) => {
            return (
              <Col key={item.id} span={11} style={{ padding: 0 }}>
                <Card>
                  <h3 className="title__avantages">{item.title}</h3>
                  <p className="text__avantages">{item.text}</p>
                </Card>
              </Col>
            );
          })}
        </div>
      </Row>
      <Row style={{ margin: 0 }} className="video__avantages content">
        <Col span={12} style={{ padding: 0 }}>
          <div className="main__avantages">
            {aboutCompany.map((item) => {
              return (
                <p className="other__avantages" key={item}>
                  {item}
                </p>
              );
            })}
          </div>
        </Col>
        <Col span={11} style={{ padding: 0 }}>
          <iframe
            src="https://rutube.ru/play/embed/e157c00985daff488a1b5973abb4c881"
            loading="lazy"
            width="100%"
            height="100%"
            title="Партнерство, которое приносит Вам прибыль в грузоперевозках❗"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </Col>
      </Row>
    </>
  );
}

export default MainPageAdvantagesSection;
